import { PerkCardProps } from 'components/perk-card';
import grooverLogo from 'assets/perks/groover-logo.svg';
import johnPageGuitarsLogo from 'assets/perks/john-page-guitars-logo.png';
import stu22Logo from 'assets/perks/stu22-logo.png';

export const perks: PerkCardProps[] = [
  {
    id: 'stu22-perk',
    title: 'STU 22 Studio Discount',
    description: 'Music & DJ studio hire in Wapping, East London',
    discount_text: '15% off studio bookings',
    code: 'SNAFU22',
    cta_label: 'Book Studio',
    cta_url: 'https://www.stu22.io/portal',
    badge: 'NEW',
    logo: stu22Logo,
    active: true,
  },
  {
    id: 'john-page-guitars-perk',
    title: 'John Page Guitars Discount',
    description: 'Hand-made in the USA',
    discount_text: '20% off John Page Guitars web store',
    note: 'Plus deeper discounts on premium guitars',
    email_code_url:
      'mailto:bryan@johnpageguitars.com?subject=SNAFU%20perk%20%E2%80%94%20John%20Page%20Guitars%20discount%20code',
    cta_label: 'Shop Guitars',
    cta_url: 'https://www.johnpageguitars.com/',
    // badge: 'NEW',
    logo: johnPageGuitarsLogo,
    active: true,
  },
  {
    id: 'groover-perk',
    title: 'Groover Promotion Discount',
    description: 'Pitch your music to curators & industry pros',
    discount_text: '10% off your first campaign',
    code: 'SNAFUGROOVERVIP',
    cta_label: 'Start Campaign',
    cta_url: 'https://groover.co/?utm_source=indirect&utm_medium=partner&utm_campaign=snafu',
    // badge: 'NEW',
    logo: grooverLogo,
    // learn_more_url: 'https://groover.co/?utm_source=indirect&utm_medium=partner&utm_campaign=snafu',
    active: true,
  },
];
